<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="p-5 text-center">
                        <router-link to="/">
                            <img src="https://test.matchday.ng/image/new_logos/test_white.png" width="130">
                        </router-link>
                    </div>
                </div>
                <div class="col-lg-4 offset-4">
                    <div class="ui-block">
                        <div class="ui-block-content text-center" v-if="is404 === true">
                            <img src="/img/404.png">
                            <h3 class=" p-4">it's likely that the link you clicked on to reset your password has expired</h3>
                            <router-link to="/" class="btn btn-primary btn-lg" > Go to Homepage </router-link>
                        </div>
                        <div v-else-if="is404 === false" ref="changePassword">
                            <div class="ui-block-title">
                                <h6 class="title" style="color: #fff">Change Password</h6>
                            </div>
                            <div class="ui-block-content">
                                <!-- Personal Information Form  -->
                                <response-message :data="errorData" />
                                <form id="password_change_form" v-on:submit.prevent="changePassword">
                                    <div class="row">
                                        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div :class="formModel.new_password === '' ? 'form-group label-floating is-empty with-button' : 'form-group label-floating with-button' ">
                                                <label class="control-label">New Password</label>
                                                <button @click="() => { oldPassword_visibility === false ? oldPassword_visibility = true : oldPassword_visibility = false } " type="button" class="bg-grey">
                                                    <svg class="olymp-computer-icon">
                                                        <use v-if="oldPassword_visibility === false " xlink:href="/svg-icons/sprites/icons.svg#olymp-check-icon"></use>
                                                        <use v-else xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"></use>
                                                    </svg>
                                                </button>
                                                <input
                                                        class="form-control"
                                                        id="new_password"
                                                        v-model="formModel.new_password"
                                                        placeholder
                                                        :type=" oldPassword_visibility === false ? 'password' : 'text' "
                                                        autocomplete="new_password"
                                                />
                                            </div>
                                        </div>

                                        <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div :class=" formModel.confirm_password === '' ? 'form-group label-floating is-empty with-button' : 'form-group label-floating with-button' ">
                                                <label class="control-label">Confirm Password</label>
                                                <button @click="() => { newPassword_visibility === false ? newPassword_visibility = true : newPassword_visibility = false } " type="button" class="bg-grey">
                                                    <svg class="olymp-computer-icon">
                                                        <use v-if="newPassword_visibility === false " xlink:href="/svg-icons/sprites/icons.svg#olymp-check-icon"></use>
                                                        <use v-else xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"></use>
                                                    </svg>
                                                </button>
                                                <input
                                                        class="form-control"
                                                        id="confirm_password"
                                                        v-model="formModel.confirm_password"
                                                        placeholder
                                                        :type=" newPassword_visibility === false ? 'password' : 'text' "
                                                        autocomplete="confirm_password"
                                                />
                                            </div>
                                        </div>

                                        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <button type="submit" class="btn bg-mdd btn-lg full-width">Change Password</button>
                                        </div>
                                    </div>
                                </form>
                                <!-- ... end Personal Information Form  -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "resetpassword",
        data() {
            return {
                formModel: {
                    old_password: "",
                    new_password: "",
                    confirm_password: "",
                },
                oldPassword_visibility: false,
                newPassword_visibility: false,
                confirmPassword_visibility: false,
                errorData: {},
                is404: false,
                email: "",
            }
        },
        mounted() {
            $("title").html("Reset Your password | Matchdaydeals");
            this.checkToken();
        },
        methods: {
            showLoading() {
                let loader = this.$loader(this, this.$refs.changePassword, {loaderType: "spinner"});
                return loader;
            },
            // validate form fields
            validateForm() {
                if (
                    this.formModel.new_password === "" &&
                    this.formModel.confirm_password === ""
                ) {
                    $("#password_change_form .label-floating").addClass('has-error')
                    $("#password_change_form input").addClass('form-control-danger')
                    this.errorData = {
                        message: "Sorry all fields are required",
                        isError: true
                    }
                    return false;
                }else if (
                    this.formModel.new_password === ""
                ) {
                    $("#password_change_form input#new_password").parent(".label-floating").addClass('has-error')
                    $("#password_change_form input#new_password").addClass('form-control-danger')
                    this.errorData = {
                        message: "Sorry set a new password",
                        isError: true
                    }
                    return false;
                }else if (
                    this.formModel.confirm_password === ""
                ) {
                    $("#password_change_form #confirm_password").parent(".label-floating").addClass('has-error')
                    $("#password_change_form input#confirm_password").addClass('form-control-danger')
                    this.errorData = {
                        message: "Sorry confirm your password",
                        isError: true
                    }
                    return false;
                }
                else if (
                    this.formModel.confirm_password !== this.formModel.new_password
                ) {
                    $("#password_change_form #confirm_password").parent(".label-floating").addClass('has-error')
                    $("#password_change_form input#confirm_password").addClass('form-control-danger')
                    this.errorData = {
                        message: "Sorry do confirm your passwords again",
                        isError: true
                    }
                    return false;
                }
                else {
                    $("#password_change_form .label-floating").removeClass('has-error')
                    $("#password_change_form input").removeClass('form-control-danger')
                    return true;
                }
            },
            // submit the password change form
            changePassword() {
                // validate the form first
                if(this.validateForm()) {
                    this.errorData = {
                      isError: false
                    };
                    let loader = this.showLoading();
                    const requestPayload = {
                        password: this.formModel.new_password,
                        password_confirmation: this.formModel.confirm_password,
                        email: this.email,
                        token: this.$route.params.token,
                    };

                    this.axios.post('/password/reset/update', requestPayload)
                        .then(response => {
                            setTimeout(()=>{
                                window.location="/";
                            },2000);
                            this.errorData = {
                                message: "Your password has been changed, redirecting...",
                                isError: "success"
                            };
                            loader.hide();
                            return response;
                        })
                        .catch(error => {
                            // console.log(error)
                            this.errorData = {
                                message: "Sorry your old password does not match what we have",
                                isError: true
                            };
                            loader.hide();
                            return error;
                        })

                }
            },
            checkToken() {
                let loader = this.showLoading();
                let token = this.$route.params.token;
                this.axios.get(`/password/find/${token}`)
                    .then(response => {
                        loader.hide();
                        if (response.data.status === false) {
                            this.is404 = true;
                        }else {
                            this.is404 = false;
                            this.email = response.data.message.email;
                        }
                    })
                    .catch(error => {
                        return error;
                    })
            },
        },
    }
</script>

<style scoped>

</style>
